import { db } from 'utils/firebase'
import { firebaseCollections as collections } from 'utils/constants'

export const fetchEmployee = async (email) => {
  try {
    console.log({ email})
    let employeeSnapshot = await db.collection(collections.employees).where('email', '==', email).get()
    if (employeeSnapshot.empty) {
      return null
    } else  {
      return { id: employeeSnapshot.docs[0].id, ...employeeSnapshot.docs[0].data() }
    }
  } catch (e) {
    console.log('ERROR', e)
    return null
  }
}

